import type { EventFilter, EventPagination, EventSort } from './types';

export const EVENTS_PER_PAGE = 12;

export const initialPagination: EventPagination = {
  current_page: 1,
  next_page: null,
  prev_page: null,
  total_pages: 1,
  total_count: 0,
  per_page: EVENTS_PER_PAGE,
};

export const eventSortOptions: Array<{ value: EventSort; label: string }> = [
  { value: 'newest', label: 'Newest' },
  { value: 'oldest', label: 'Oldest' },
  { value: 'updated', label: 'Updated' },
  { value: 'name_asc', label: 'A to Z' },
  { value: 'name_desc', label: 'Z to A' },
];

export const eventFilterOptions: Array<{ value: EventFilter; label: string }> = [
  { value: 'all', label: 'All events' },
  { value: 'manual', label: 'Created events' },
  { value: 'default', label: 'Default event' },
];
